import { useMatchEnvironment } from "../../modules/environment/envHooks"
import { EnvironmentType } from "../../modules/environment/envTypes"
import { selectUserType } from "../../modules/login/loginSelectors"
import { UserType } from "../../modules/login/loginTypes"
import { useAppSelector } from "../../modules/store/storeHooks"

export function useCanImpersonate(): boolean {
    const isSupporter = useAppSelector(selectUserType) === UserType.SUPPORT
    // Not on prod until the backend ships the impersonation endpoint
    const isImpersonationEnv = useMatchEnvironment([EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.QA])
    // Only supporters may impersonate, and only the actual login type counts
    return isSupporter && isImpersonationEnv
}
